<template>
  <div class="login-container">
    <form class="login-form" @submit.prevent="login">
      <label for="email">Email:</label>
      <input v-model="email" type="email" class="form-control" required />

      <label for="password">Password:</label>
      <input v-model="password" type="password" class="form-control" required />

      <button type="submit" class="btn btn-primary">Log In</button>

      <div v-if="error" class="mt-3 text-danger">
        {{ error }}
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { login } from '@/common/api';
import TokenService from '@/services/TokenService';
import { defineComponent } from 'vue';
import { handleError } from '@/common/errors';

export default defineComponent({
  name: 'LoginView',

  data() {
    return {
      email: '',
      password: '',
      error: '',
    };
  },

  async mounted() {
    await this.redirectIfLoggedIn();
  },

  methods: {
    async login() {
      try {
        const email = this.email.trim();

        const tokenResponse = await login(email, this.password);
        const token = tokenResponse.data.token;

        if (token) {
          TokenService.setToken(token);
          this.$router.push('/user-profile?page=1');
        } else {
          throw new Error('Token not received from login response');
        }
      } catch (error: unknown) {
        handleError(error, 'Failed to log in');
        this.error = 'Invalid Email or Password';
      }
    },

    async redirectIfLoggedIn() {
      const isValid = await TokenService.validateToken();
      if (isValid) {
        this.$router.push('/user-profile?page=1');
      }
    },
  },
});
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(to bottom, #f5f5f5, #e0e0e0);
}

.login-form {
  max-width: 300px;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: bold;
  color: #333;
}

input {
  width: calc(100% - 16px);
  padding: 8px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px; /* Размер шрифта */
}
</style>
